import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";

function Team() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: "1400px",
            padding: { xs: "65px 0px 107px", lg: "140px 0px" },
            margin: "auto",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "#000",
              fontWeight: 700,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 36, lg: 54 },
              lineHeight: { xs: "44px", lg: "65px" },
              maxWidth: "800px",
              margin: { xs: "auto", lg: 0 },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            Our Team
          </Typography>
          <Typography
            sx={{
              color: "#000",
              fontWeight: 400,
              fontFamily: '"Inter", sans-serif',
              fontSize: { xs: 18, lg: 22 },
              padding: "24px 0px 60px",
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            <br /><strong>Yunus BECIT (CEO)</strong><br /><br />
            Born in Istanbul in 1989, Yunus Becit completed his high school education at Bayrampasa Anatolian High School and his undergraduate education at Bahcesehir University Law Department. He is pursuing a master's degree with a thesis in Advertising and Strategic Brand Management at Istanbul Commerce University.<br /><br />
            Being a lawyer, Yunus Becit has been registered with the bar association for 8 years. He is actively engaged in trade and advertising.<br /><br />
            Yunus Becit provides consultancy to various institutions and individuals on subjects such as communication, digital marketing, social media, perception and reputation management, and political communication.<br /><br />
            He continues his duty as Agency President/Chairman of the Board at Papillon Istanbul company, which he founded in 2011, and FIA-Financial Communication company, which he founded in 2019.<br /><br />
            The Financial Communication Agency he founded in 2019 is the first financial communication agency in the finance vertical in both Türkiye and the World. It continues to serve all major financial institutions of Türkiye for 6 years.<br /><br />
            Establishing Povego, Türkiye's first token marketplace, in 2023 with FIA experience, Yunus Becit realized his first fintech initiative.<br /><br />
            He takes part as an investor in many different sectors. The main sectors he invests in are media, gaming, fintech, software, e-export, and energy sectors.<br /><br />
            Residing in Uskudar Cengelkoy, Yunus Becit is a father of three children.<br /><br />

            <strong>Ufuk KORCAN</strong><br /><br />
            Graduating from Istanbul University Faculty of Economics, Department of Economics in 1998, Ufuk Korcan started his working life as an Economy Correspondent at Radikal Newspaper in 1997. Subsequently, he worked as a finance editor at Vatan Magazine Group, Referans Newspaper, and Vatan Newspaper. Ufuk Korcan, who also worked as a columnist alongside being a finance editor at Vatan Newspaper, later carried out the duty of economy coordinator at haberturk.com. Following this duty, he worked as Economy Manager at Aksam Newspaper. Finally continuing his working life as Editor-in-Chief at Financial Communication Agency, Ufuk Korcan is also a columnist at Dunya Newspaper.<br /><br />
            Speaking English at a good level, Ufuk Korcan is married and a father of 1 child.<br /><br />
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default Team;
